// extracted by mini-css-extract-plugin
export var customFont = "CarouselV1-module--customFont--a209f";